import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Colors, Spacing, FontSizes, FontWeights, FontStacks } from '../constants/theme';

const FooterContainer = styled.footer`
  background: ${Colors.surface};
  border-top: 1px solid ${Colors.border};
  padding: ${Spacing.xl}px ${Spacing.xl}px;
  margin-top: auto;
  position: relative;
  font-family: ${FontStacks.primary};
`;

const FooterContent = styled.div`
  max-width: 1400px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${Spacing.xl}px;
  
  @media (max-width: 768px) {
    flex-direction: column;
    text-align: center;
    gap: ${Spacing.md}px;
  }
`;

const BrandSection = styled.div`
  display: flex;
  align-items: center;
  gap: ${Spacing.md}px;
`;

const Logo = styled.a`
  display: flex;
  align-items: center;
  text-decoration: none;
  transition: opacity 0.2s ease;
  
  &:hover {
    opacity: 0.8;
  }
`;

const LogoImage = styled.img`
  height: 40px;
  width: auto;
  object-fit: contain;
`;

const LinksSection = styled.div`
  display: flex;
  gap: ${Spacing.xl}px;
  align-items: center;
  
  @media (max-width: 768px) {
    flex-direction: column;
    gap: ${Spacing.md}px;
  }
`;

const FooterLink = styled.a`
  display: flex;
  align-items: center;
  gap: ${Spacing.xs}px;
  text-decoration: none;
  color: ${Colors.textSecondary};
  font-size: ${FontSizes.sm}px;
  font-weight: ${FontWeights.medium};
  padding: ${Spacing.xs}px ${Spacing.sm}px;
  border-radius: 6px;
  transition: all 0.2s ease;
  
  &:hover {
    color: ${Colors.secondary};
    background: ${Colors.surfaceHover};
  }
  
  &:focus {
    outline: none;
    color: ${Colors.secondary};
    background: ${Colors.surfaceHover};
    box-shadow: 0 0 0 2px ${Colors.secondary}20;
  }
`;



const BrandedFooter: React.FC = () => {
  const { t } = useTranslation();

  return (
    <FooterContainer>
      <FooterContent>
        <BrandSection>
          <Logo 
            href="https://cloudsonmars.com" 
            target="_blank" 
            rel="noopener noreferrer"
            aria-label={t('footer.visitWebsite')}
          >
            <LogoImage 
              src="/assets/Clouds On Mars - Logotype with Slogan - Martian Orange - Horizontal.png"
              alt="Clouds on Mars - Turning Ideas Into Reality"
            />
          </Logo>
        </BrandSection>

        <LinksSection>
          <FooterLink
            href="https://cloudsonmars.com"
            target="_blank"
            rel="noopener noreferrer"
            aria-label={t('footer.contactUs')}
          >
            {t('footer.contactUs')}
          </FooterLink>
          
          <FooterLink
            href="https://cloudsonmars.ch"
            target="_blank"
            rel="noopener noreferrer"
            aria-label={t('footer.moreDemos')}
          >
            {t('footer.moreDemos')}
          </FooterLink>
        </LinksSection>
      </FooterContent>
    </FooterContainer>
  );
};

export default BrandedFooter;